import {http} from '~/services/http';

import {LOAD_DIETARY} from './types';

export const loadDietaryAction = () => async (dispatch) => {

    const response = await http.get('/dietaries');

    dispatch({
        type: LOAD_DIETARY,
        payload: response?.data || []
    });
};
